import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";

// Children
import DocumentView from "./single-student-documents-view";

// Dialogues
import DialogueCreateDocumentPersonal from "routes/dashboard/dialogues/students/create-document-personal";
import DialogueDeleteDocument from "routes/dashboard/dialogues/students/delete-document";

// Actions
import { getAssociatedDocumentsPersonal } from "repository/actions/data/dashboard/students";

export default withRouter(function (props) {
  const { student, setStudent, user, getStudent, editStudent} = props;

  const [documents, setDocuments] = useState(null);

  const [showNewDocumentDialogue, setShowNewDocumentDialogue] = useState(false);
  const [showDeleteDocumentDialogue, setShowDeleteDocumentDialogue] =
    useState(false);

  const [selectedId, setSelectedId] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(null);

  // Data Fetching
  useEffect(() => {
    if (user && user != null) {
      if (student != null) {
        getAssociatedDocumentsPersonal(student._id, user.idToken).then(
          (result) => {
            setDocuments(result.data);
          }
        );
      }
    }
  }, [student]);

  // Editing Item
  let editingItem = null;
  if (documents) {
    if (documents[selectedIndex]) {
      editingItem = documents[selectedIndex];
    }
  }

  return (
    <div>
      <DocumentView
        loading={!documents}
        toggleAddCourseForm={() => setShowNewDocumentDialogue(true)}
        sectionDescription={
          "You can view and delete all related personal documents below."
        }
        documents={documents || []}
        setDocuments={setDocuments}
        student={student}
        onPressedDeleteItem={(index) => {
          setSelectedId(index);
          setShowDeleteDocumentDialogue(true);
        }}
        user={user}
        setStudent={setStudent}
        editStudent={editStudent}
        getStudent={getStudent}
      />
      <DialogueCreateDocumentPersonal
        isOpen={showNewDocumentDialogue}
        setClose={() => setShowNewDocumentDialogue(false)}
        documents={documents || []}
        setDocuments={setDocuments}
        student={student}
        user={user}
        setStudent={setStudent}
        editStudent={editStudent}
        getStudent={getStudent}
      />
      <DialogueDeleteDocument
        isOpen={showDeleteDocumentDialogue}
        setClose={() => setShowDeleteDocumentDialogue(false)}
        itemId={selectedId}
        documents={documents || []}
        setDocuments={setDocuments}
        user={user}
        setStudent={setStudent}
        editStudent={editStudent}
        getStudent={getStudent}
      />
    </div>
  );
});
